<div class="row nopaddleft compwidth" [formGroup]="studyForm">
  <div class="col d-flex">
    <div>
      <mat-form-field class="editor" [hideRequiredMarker]="true">
        <mat-select
          formControlName="modality"
          (selectionChange)="studyForm.controls.studyId.reset()"
          id="modality"
          placeholder="Select Modality"
          required
        >
          <mat-option *ngFor="let m of modalityList" value="{{ m }}">
            {{ m }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            studyForm.controls.modality.invalid &&
            (studyForm.controls.modality.dirty ||
              studyForm.controls.modality.touched)
          "
          class="invalid-feedback"
        >
          <div *ngIf="studyForm.controls.modality.errors.required">
            Please select a Modality.
          </div>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="ml-3">
      <mat-form-field class="editor" [hideRequiredMarker]="true">
        <mat-select
          formControlName="studyId"
          id="studyId"
          placeholder="Select Study"
          [panelWidth]="null"
          required
        >
          <mat-option [hidden]="studyForm.controls.modality.invalid">
            <ngx-mat-select-search
              [formControl]="searchControl"
              placeholderLabel="Type to search"
              noEntriesFoundLabel="Not found"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let sd of studyOptions | async"
            [value]="sd.studyId"
          >
            {{ sd.description }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            studyForm.controls.studyId.invalid &&
            (studyForm.controls.studyId.dirty ||
              studyForm.controls.studyId.touched)
          "
          class="invalid-feedback"
        >
          <div *ngIf="studyForm.controls.studyId.errors.required">
            Please select a Study Description.
          </div>
          <div *ngIf="studyForm.controls.studyId.errors.duplicatedstudy">
            Duplicated Study is not allowed.
          </div>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="ml-3">
      <mat-form-field class="editor">
        <input
          type="number"
          matInput
          formControlName="noOfImages"
          id="noOfImages"
          min="1"
          (keypress)="inputDigitOnly($event)"
          (input)="integerOnly(studyForm.controls.noOfImages)"
          required
        />
        <mat-error
          *ngIf="
            studyForm.controls.noOfImages.invalid &&
            (studyForm.controls.noOfImages.dirty ||
              studyForm.controls.noOfImages.touched)
          "
          class="invalid-feedback"
        >
          <div *ngIf="studyForm.controls.noOfImages.errors.required">
            Image Count is required.
          </div>
          <div *ngIf="studyForm.controls.noOfImages.errors.min">
            Image Count cannot be smaller than one.
          </div>
          <div *ngIf="studyForm.controls.noOfImages.errors.max">
            Image Count cannot be greater than 9999999.
          </div>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="ml-3">
      <mat-form-field class="editor">
        <input
          type="text"
          matInput
          formControlName="accessionNumber"
          id="accessionNumber"
        />
        <mat-error
          *ngIf="
            studyForm.controls.accessionNumber.invalid &&
            (studyForm.controls.accessionNumber.dirty ||
              studyForm.controls.accessionNumber.touched)
          "
          class="invalid-feedback"
        >
          <div *ngIf="studyForm.controls.accessionNumber.errors.maxlength">
            Accession Number must be no more than 50 characters long.
          </div>
          <div *ngIf="studyForm.controls.accessionNumber.errors.pattern">
            Invalid characters in the field.
          </div>
        </mat-error>
      </mat-form-field>
    </div>
    <ng-content></ng-content>
  </div>
</div>
